import { Button, Card, Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionTasksGeneral } from './SectionTasksGeneral';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';
import { SectionRuntimeConfigs } from '../shared/SectionRuntimeConfigs';

const TASK_CFG_FILTER = (k: string) => /newbie_first_deposit_threshold/i.test(k);

export default function BlindBoxTasksList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-tasks" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.tasks')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.tasks') },
          ]}
          action={
            <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>
              {t('module.blindBox.refreshAll')}
            </Button>
          }
        />
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <SectionTasksGeneral refreshKey={refreshKey} />
          </Card>

          {/* Runtime configs: Task configuration */}
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <SectionRuntimeConfigs refreshKey={refreshKey} keyFilter={TASK_CFG_FILTER} />
          </Card>
        </Stack>
      </DashboardContent>
    </PermissionGuard>
  );
}
